/* eslint-disable id-length */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-var-requires */
const plugin = require("tailwindcss/plugin");

const alertBanner = require("./lib/alert-banner/alert-banner");
const baseBlock = require("./lib/base-block/base-block");
const breadcrumb = require("./lib/breadcrumb/breadcrumb");
const button = require("./lib/button/button");
const calendar = require("./lib/calendar/calendar");
const caps = require("./lib/caps/caps");
const checkbox = require("./lib/checkbox/checkbox");
const clearSender = require("./lib/clear-sender/clear-sender");
const contentGroup = require("./lib/content-group/content-group");
const customerServiceFunnel = require("./lib/customer-service-funnel/customer-service-funnel");
const details = require("./lib/details/details");
const dialog = require("./lib/dialog/dialog");
const directSearchContainer = require("./lib/direct-search-container/direct-search-container");
const dl = require("./lib/dl/dl");
const editorial = require("./lib/editorial/editorial");
const error = require("./lib/error/error");
const faq = require("./lib/faq/faq");
const field = require("./lib/field/field");
const footer = require("./lib/footer/footer");
const grid = require("./lib/grid/grid");
const header = require("./lib/header/header");
const headingBlock = require("./lib/heading-block/heading-block");
const headings = require("./lib/headings/headings");
const heroGroup = require("./lib/hero-group/hero-group");
const hero = require("./lib/hero/hero");
// Old Icon reference to be decommissioned later
const icon = require("./lib/icon");
const icons = require("./lib/icons/icons");
const imageBlock = require("./lib/image-block/image-block");
const link = require("./lib/link/link");
const list = require("./lib/list/list");
const logotype = require("./lib/logotype/logotype");
const message = require("./lib/message/message");
const navbar = require("./lib/navbar/navbar");
const option = require("./lib/option/option");
const overlay = require("./lib/overlay/overlay");
const posterGroup = require("./lib/poster-group/poster-group");
const preamble = require("./lib/preamble/preamble");
const quickLinks = require("./lib/quick-links/quick-links");
const radio = require("./lib/radio/radio");
const responsiveBackgroundImage = require("./lib/responsive-background-image/responsive-background-image");
const section = require("./lib/section/section");
const serviceBlock = require("./lib/service-block/service-block");
const switchComponent = require("./lib/switch/switch");
const teaser = require("./lib/teaser/teaser");
const textBlock = require("./lib/text-block/text-block");
const textIconGroup = require("./lib/text-icon-group/text-icon-group");
const text = require("./lib/text/text");
const textLarge = require("./lib/textLarge/textLarge");
const tooltip = require("./lib/tooltip/tooltip");
const upsale = require("./lib/upsale-block/upsale-block");

const FONT_PATH = "https://elements.vattenfall.se/fonts";

function colorTones(hex) {
  return {
    DEFAULT: `${hex}`,
    70: `${hex}70`,
    50: `${hex}50`,
    30: `${hex}30`,
    10: `${hex}10`,
  };
}

module.exports = {
  // Adding prefix to avoid naming conflicts with legacy styles
  prefix: "ds-",
  theme: {
    extend: {
      width: {
        screen: "100vw",
      },
    },
    screens: {
      xs: "375px",
      sm: "599px",
      md: "768px",
      lg: "1024px",
      xl: "1440px",
    },
    spacing: {
      // 0px
      0: "0rem",
      // 1px
      px: "1px",
      // 4px
      "2xs": "0.25rem",
      // 8px
      xs: "0.5rem",
      // 12px
      sm: "0.75rem",
      // 16px
      DEFAULT: "1rem",
      // 24px
      lg: "1.5rem",
      // 28px
      xl: "1.75rem",
      // 44px
      "2xl": "2.75rem",
      // 58px
      "3xl": "3.6rem",
      // 88px
      "4xl": "5.5rem",
      // 256px
      "5xl": "16rem",
    },
    colors: {
      transparent: "transparent",
      current: "currentColor",
      primary: {
        white: "#FFFFFF",
        yellow: colorTones("#FFDA00"),
        blue: colorTones("#2071B5"),
        black: colorTones("#000000"),
        gray: colorTones("#4E4B48"),
      },
      secondary: {
        darkgreen: colorTones("#005C63"),
        darkblue: colorTones("#1E324F"),
        pink: colorTones("#D1266B"),
        darkpurple: colorTones("#85254B"),
        green: colorTones("#3DC07C"),
        red: colorTones("#F93B18"),
        purple: colorTones("#9B62C3"),
      },
      background: {
        white: "#FFFFFF",
        yellow: "#FFFEE5",
        green: "#EDF9F3",
        bluealt: "#EBF2F3",
        blue: "#EDF1F6",
        red: "#FEF0EA",
        grey: "#F2F2F2",
      },
      tertiary: {
        blue: "#869BAD",
        darkblue: "#69788C",
        lightergrey: "#E6E6E6",
        lightgrey: "#CCCCCC",
        mediumgrey: "#999999",
        darkgrey: "#666666",
      },
      energysource: {
        hydro: colorTones("#2DA55D"),
        wind: colorTones("#4FCC51"),
        solar: colorTones("#81E0A8"),
        biomass: colorTones("#375E4E"),
        coal: colorTones("#E88A74"),
        gas: colorTones("#D85067"),
        nuclear: colorTones("#203D5D"),
        district: colorTones("#A376CC"),
      },
    },
    borderColor: (theme) => ({
      ...theme("colors"),
      DEFAULT: theme("colors.tertiary.lightergray", "currentColor"),
    }),
    fontFamily: {
      regular: ["'Vattenfall Hall', Helvetica, sans-serif"],
      display: ["'Vattenfall Hall Display', Helvetica, sans-serif"],
      icons: ["'Vattenfall Elements Icons', 'Vattenfall Icons'"],
    },
    fontSize: {
      // 12px
      xs: "0.75rem",
      // 14px
      sm: "0.875rem",
      // 16px
      base: "1rem",
      // 18px
      lg: "1.125rem",
      // 20px
      xl: "1.25rem",
      // 22px
      "2xl": "1.375rem",
      // 24px
      "3xl": "1.5rem",
      // 28px
      "4xl": "1.75rem",
      // 34px
      "5xl": "2.125rem",
      // 36px
      "6xl": "2.25rem",
      // 52px
      "7xl": "3.25rem",
    },
    fontWeight: {
      light: "300",
      regular: "400",
      medium: "500",
      bold: "600",
    },
    lineHeight: {
      // 22px
      xs: "1.375rem",
      // 24px
      sm: "1.5rem",
      // 28px
      base: "1.75rem",
      // 32px
      lg: "2rem",
      // 36px
      xl: "2.25rem",
      // 40px
      "2xl": "2.5rem",
      // 42px
      "3xl": "2.625rem",
      // 62px
      "4xl": "3.875rem",
    },
    maxWidth: {
      // 0px;
      0: "0rem",
      // 32px
      xs: "2rem",
      // 72px
      sm: "4.5rem",
      // 256px
      DEFAULT: "16rem",
      // 333px
      lg: "20.8125rem",
      // 648px
      xl: "40.5rem",
      // 944px
      "2xl": "59rem",
      // 1128px
      "3xl": "70.5rem",
      // 1440px
      "4xl": "90rem",
      none: "none",
      full: "100%",
      min: "min-content",
      max: "max-content",
      prose: "65ch",
    },
    minWidth: {
      // 0px;
      0: "0rem",
      // 32px
      xs: "2rem",
      // 72px
      sm: "4.5rem",
      // 256px
      DEFAULT: "16rem",
      // 333px
      lg: "20.8125rem",
      // 648px
      xl: "40.5rem",
      // 944px
      "2xl": "59rem",
      // 1128px
      "3xl": "70.5rem",
      full: "100%",
      min: "min-content",
      max: "max-content",
    },
  },
  plugins: [
    plugin(function ({ addBase, addComponents, addVariant, addUtilities, theme, e }) {
      addBase({
        "@font-face": {
          fontFamily: "Vattenfall Hall",
          fontWeight: theme("fontWeight.light"),
          fontStyle: "normal",
          src: `url("${FONT_PATH}/VattenfallHall-Light.eot") format("eot"), url("${FONT_PATH}/VattenfallHall-Light.woff2") format("woff2"), url("${FONT_PATH}/VattenfallHall-Light.woff") format("woff")`,
        },
      });
      addBase({
        "@font-face": {
          fontFamily: "Vattenfall Hall",
          fontWeight: theme("fontWeight.regular"),
          fontStyle: "normal",
          src: `url("${FONT_PATH}/VattenfallHall-Regular.eot") format("eot"), url("${FONT_PATH}/VattenfallHall-Regular.woff2") format("woff2"), url("${FONT_PATH}/VattenfallHall-Regular.woff") format("woff")`,
        },
      });
      addBase({
        "@font-face": {
          fontFamily: "Vattenfall Hall",
          fontWeight: theme("fontWeight.medium"),
          fontStyle: "normal",
          src: `url("${FONT_PATH}/VattenfallHall-Medium.eot") format("eot"), url("${FONT_PATH}/VattenfallHall-Medium.woff2") format("woff2"), url("${FONT_PATH}/VattenfallHall-Medium.woff") format("woff")`,
        },
      });
      addBase({
        "@font-face": {
          fontFamily: "Vattenfall Hall",
          fontWeight: theme("fontWeight.bold"),
          fontStyle: "normal",
          src: `url("${FONT_PATH}/VattenfallHall-Bold.eot") format("eot"), url("${FONT_PATH}/VattenfallHall-Bold.woff2") format("woff2"), url("${FONT_PATH}/VattenfallHall-Bold.woff") format("woff")`,
        },
      });
      addBase({
        "@font-face": {
          fontFamily: "Vattenfall Hall Display",
          fontWeight: theme("fontWeight.bold"),
          fontStyle: "normal",
          src: `url("${FONT_PATH}/VattenfallHallDisplay-Bold.eot") format("eot"), url("${FONT_PATH}/VattenfallHallDisplay-Bold.woff2") format("woff2"), url("${FONT_PATH}/VattenfallHallDisplay-Bold.woff") format("woff")`,
        },
      });
      addBase({
        "@font-face": {
          fontFamily: "Vattenfall Elements Icons",
          fontWeight: "normal",
          fontStyle: "normal",
          fontVariant: "normal",
          textTransform: "none",
          lineHeight: "1",
          "-webkit-font-smoothing": "antialiased",
          "-moz-osx-font-smoothing": "grayscale",
          src: `url("${FONT_PATH}/VattenfallElements-Icons.eot") format("eot"), url("${FONT_PATH}/VattenfallElements-Icons.woff") format("woff"), url("${FONT_PATH}/VattenfallElements-Icons.ttf") format("truetype")`,
        },
      });
      addBase({
        "*": {
          fontFamily: "'Vattenfall Hall', Helvetica, sans-serif",
          fontStyle: "normal",
        },
        a: {
          // There is no color in the existing palette that match this so are hardcoding the hex representation
          // Source: https://digitaldesign.vattenfall.com/lib/colors
          color: "#2071b5",
          "&:hover": {
            color: "inherit",
          },
        },
      });
      addVariant("open", ({ modifySelectors, separator }) => {
        modifySelectors(({ className }) => {
          return `[open].open\\${separator}${className}[open], details[open] .open\\${separator}${className}`;
        });
      });
      addVariant("close", ({ modifySelectors, separator }) => {
        modifySelectors(({ className }) => {
          return `[close].close\\${separator}${className}:not([open]), details:not([open]) .close\\${separator}${className}`;
        });
      });
      addVariant("before", ({ modifySelectors, separator }) => {
        modifySelectors(({ className }) => {
          return `.${e(`before${separator}${className}`)}::before`;
        });
      });
      addVariant("after", ({ modifySelectors, separator }) => {
        modifySelectors(({ className }) => {
          return `.${e(`after${separator}${className}`)}::after`;
        });
      });
      addComponents(alertBanner(theme));
      addComponents(breadcrumb(theme));
      addComponents(calendar(theme));
      addComponents(caps(theme));
      addComponents(calendar(theme));
      addComponents(checkbox(theme));
      addComponents(clearSender());
      addComponents(contentGroup());
      addComponents(customerServiceFunnel(theme));
      addComponents(details(theme));
      addComponents(dialog(theme));
      addComponents(directSearchContainer(theme));
      addComponents(dl(theme));
      addComponents(editorial(theme));
      addComponents(error(theme));
      addComponents(faq(theme));
      addComponents(field(theme));
      addComponents(baseBlock(theme));
      addComponents(grid(theme));
      addComponents(headings(theme));
      // Old Icon reference to be decommissioned later
      addComponents(icon(theme));
      addComponents(icons(theme));
      addComponents(link(theme));
      addComponents(list(theme));
      addComponents(logotype(theme));
      addComponents(message(theme));
      addComponents(option(theme));
      addComponents(overlay(theme));
      addComponents(posterGroup(theme));
      addComponents(preamble(theme));
      addComponents(quickLinks(theme));
      addComponents(radio(theme));
      addComponents(responsiveBackgroundImage(theme));
      addComponents(section(theme));
      addComponents(serviceBlock(theme));
      addComponents(switchComponent(theme));
      addComponents(teaser(theme));
      addComponents(textLarge(theme));
      addComponents(text(theme));
      addComponents(button(theme));
      addComponents(footer(theme));
      addComponents(header(theme));
      addComponents(navbar(theme));
      addComponents(hero(theme));
      addComponents(heroGroup(theme));
      addComponents(upsale(theme));
      addComponents(textBlock(theme));
      addComponents(textIconGroup(theme));
      addComponents(imageBlock(theme));
      addComponents(headingBlock(theme));
      addComponents(tooltip(theme));
      // The following definitions are used only in the header.
      addUtilities(
        {
          ".icon-up::before": {
            content: '"\\e98c"',
          },
          ".icon-bottom::before": {
            content: '"\\e981"',
          },
          ".icon-minus::before": {
            content: '"\\e984"',
          },
          ".icon-plus::before": {
            content: '"\\e987"',
          },
          ".icon-cross::before": {
            content: '"\\e980"',
          },
          ".icon-menu::before": {
            content: '"\\e986"',
          },
        },
        ["checked"]
      );
      // Hides scrollbar but still allows the element to be scrollable
      addUtilities({
        ".scrollbar-hide": {
          /* IE and Edge */
          "-ms-overflow-style": "none",
          /* Firefox */
          "scrollbar-width": "none",
          /* Safari and Chrome */
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
      });
    }),
  ],
};
